import React from "react"

import {
  styled
} from "@mui/material"

const StyledRichText = styled("div", {
})(({ theme, grey }) => {
  return {
    background: grey ? theme.palette.grey[200] : "transparent",
    borderRadius: theme.shape.borderRadius,
    padding: grey ? theme.spacing(3) : 0,
    "& > h3": {
      marginBottom: theme.spacing(1)
    },
    "& > p": {
      marginBottom: theme.spacing(2)
    },
    "& > p:last-child": {
      marginBottom: 0
    },
    "& .lead": {
      fontSize: theme.typography.pxToRem(32)
    },
    [theme.breakpoints.down("md")]: {
      "& .lead": {
        fontSize: theme.typography.pxToRem(24),
      }
    },
    [theme.breakpoints.down("sm")]: {
      "& .lead": {
        fontSize: theme.typography.pxToRem(22),
      }
    }
  }
})

const RichText = React.memo(({ children, ...props }) => {

  return <StyledRichText {...props}>
    {children}
  </StyledRichText>
})

export default React.memo(RichText)